import { OptionsPaneLoading } from 'owa-options-loading';
import { useOptionLayout, OptionLayout } from './hooks/useOptionLayout';
import * as React from 'react';

const styles = require('./OptionsFull.scss');

/**
 * Content of the options modal shown while allowed subcategories are still loading in store
 */
const OptionsFullWithPendingCategoriesContent = () => {
    const layout = useOptionLayout();
    return (
        <>
            {(layout === OptionLayout.ThreeColumn || layout === OptionLayout.TwoColumn) && (
                <div className={styles.categoriesColumn} role="tablist" />
            )}
            {layout === OptionLayout.ThreeColumn && (
                <div className={styles.optionsColumn} role="tablist" />
            )}
            <div className={styles.settingsPane}>
                <OptionsPaneLoading />
            </div>
        </>
    );
};

export default OptionsFullWithPendingCategoriesContent;
